/* eslint-disable */
const creative = [{
    "_id": "68199fbb5aa9f81157053a62",
    "ad_name": "Ocean Spray Healthy Juice",
    "width": "1920",
    "height": "1080",
    "accountId": "59fa3207-b3dc-43f2-bd99-dd147cea0a43",
    "accountName": "Nature",
    "dimension": "1920x1080",
    "device": "3",
    "ad_for": "nexd",
    "ad_type": "Video",
    "decarbonise_options": "{\"max\":91,\"min\":40,\"ar\":50,\"calc\":91,\"lod\":50,\"decarbonise\":false}",
    "dimensionId": "239",
    "superFormatId": "80",
    "ad_id": "00a4b2e4-6385-40c1-adec-323033430931",
    "creative_id": "shN6LT0UF2AssHUM",
    "html_tag": "<ins class=\"adcads\"\r\ndata-click-tracker=\"https://bigads.co\"\r\ndata-debug=\"true\"\r\ndata-has-desktop=\"yes\"\r\ndata-preview-site=\"true\"\r\ndata-settings=\"https://data-apse1.nexd.com/ads/creatives/shN6LT0UF2AssHUM/settings.json?8d9dcb0451b54f9078de7cc51ce29cb6c582be0b\"\r\ndata-stay-in-container=\"true\"\r\ndata-tracking=\"no\"\r\ndata-trackingjs=\"no\"\r\ndata-unit=\"shN6LT0UF2AssHUM\"\r\ndata-url=\"https://data-apse1.nexd.com/ads/creatives/\">\r\n<script src=\"https://cdn.nexd.com/frmwrk/teele-release-v6.1.37.js\" type=\"text/javascript\" async></script>\r\n</ins>",
    "refName": "Ocean Spray Instream",
    "default_landingURL": "https://bigads.co",
    "createAt": "2025-05-06 05:35:55",
    "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49",
    "content": [
        {
            "imageSrc": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/682fb3eb932f37298a0bad04/ss/image682fb3f2aa394.jpeg",
            "createAt": "2025-05-06 05:35:55",
            "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49"
        }
    ],
    "tagRequested": "true",
    "tagRequestedTime": "2025-05-06 05:35:55",
    "payload_size": 2271736,
    "scripts": {
        "secureScript": "https://media.adcanvas.com/KovWI2Gg6qZP/KovWI2Gg6qZP.xml",
        "adcId": "creative-c"
    },
    "status": {
        "ad_live": true
    },
    "ss": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/682fb3eb932f37298a0bad04/ss/image682fb3f2aa394.jpeg",
    "ad_server": "nexd",
    "format_type": "VPAID",
    "creative_number": 0
}

];

const media = [
    {        
        "id": "7b84ae77-b125-4ff3-b90f-fc1c0d508979",
        "countryId": 15,
        "accountId": "dd6cfb6b-9a93-4db4-963c-7993c3590872",
        "dspId": 2249,
        "currencyCode": "AUD",
        "name": "Run of Network",
        "token": "BIG-AU-DV3-INSV-RON-DEMO",
        "card": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/prodBuddy/g_prebuilt_media_master/card/aa641cbd-8e9d-4e77-9619-923d59ae0f50/Video RON.png",
        "priceFloor": "15",
        "priceModel": "Fixed",
        "mediaType": "Mobile Web, Desktop",
        "description": "<p></p>",
        "topSites": "[{\"domain\":\"1000logos.net\",\"publisher\":\"Commerce Grid\",\"adRequests\":42000,\"integrationMethod\":\"Silent\",\"isOptional\":true,\"em\":95.498},{\"domain\":\"1000rr.net\",\"publisher\":\"Commerce Grid\",\"adRequests\":14000,\"integrationMethod\":\"Silent\",\"isOptional\":true,\"em\":1885.5055},{\"domain\":\"1001freefonts.com\",\"publisher\":\"Commerce Grid\",\"adRequests\":14000,\"integrationMethod\":\"Silent\",\"isOptional\":true,\"em\":135.4673},{\"domain\":\"101cookbooks.com\",\"publisher\":\"Commerce Grid\",\"adRequests\":84000,\"integrationMethod\":\"Silent\",\"isOptional\":true,\"em\":95.4695},{\"domain\":\"101planners.com\",\"publisher\":\"Commerce Grid\",\"adRequests\":42000,\"integrationMethod\":\"Silent\",\"isOptional\":true,\"em\":95.5732},{\"domain\":\"10fastfingers.com\",\"publisher\":\"Commerce Grid\",\"adRequests\":140000,\"integrationMethod\":\"Silent\",\"isOptional\":true,\"em\":231.873},{\"domain\":\"123homeschool4me.com\",\"publisher\":\"Commerce Grid\",\"adRequests\":28000,\"integrationMethod\":\"Silent\",\"isOptional\":true,\"em\":95.5801},{\"domain\":\"12tomatoes.com\",\"publisher\":\"Commerce Grid\",\"adRequests\":70000,\"integrationMethod\":\"Silent\",\"isOptional\":true,\"em\":126.0118}]",
        "uniqueVisitors": "21500000",
        "adRequests": "1370976277",
        "audienceFact": "100",
        "audienceBehavior": "Australians of all ages and genders",
        "status": true,
        "createdBy": "8b717c63-6cc5-4393-9166-9f89806ea26c",
        "createdOn": "2025-05-22 00:55:43+00",
        "updatedOn": null,
        "updatedBy": null,
        "dealTypeId": "2568ef31-343c-40ff-8fd4-f561e597557a",
        "jobStatus": "Demo",
        "numberOfSites": "3011",
        "type": "Pre-built",
        "live_date": "2025-05-22",
        "brief_date": "2025-05-22",
        "master_template_id": "aa641cbd-8e9d-4e77-9619-923d59ae0f50",
        "internalNotes": null,
        "dealName": "[BigMobile_DeaL]-AU-INSV-Run_of_Network",
        "dspBuyerId": "2850832",
        "supplyPlatform": "Magnite",
        "decarbonise": false,
        "dataProvider": "{\"provider\":\"\",\"provider_id\":\"\",\"segment_targeting\":\"\",\"provider_price\":0,\"provider_logo\":\"\",\"segment_targeting_category_ids\":\"\"}",
        "addon_booster": false
    }
];

const dealInfo = {
    "id": "9149cf5d-b063-4d05-8cbc-9c99c2b9535e",
    "accountId": "",
    "accountName": "Nature",
    "networkName": "Nature",
    "name": "Ocean Spray Instream",
    "decarbonise": "off",
    "measure_emissions": false,
    "dspId": 2249,
    "dsp_buyer_id": "2850832",
    "is_tnc_accepted": true,
    "is_mobile_app": false,
    "dealType": "2568ef31-343c-40ff-8fd4-f561e597557a",
    "createdBy": "admin",
    "createdOn": "2025-05-01 10:04:12",
    "updatedOn": Date.now(),
    "selectedMedias": "nature-medias",
    "status": 1,
    "ext_campaign_id_n": "nowhere",
    "ext_campaign_id_a": "nowhere",
    "userName": "Admin",
    "isDemo": false,

    "measure_emissions": false,
    "decarbonise": "off",
    "decarbonise_options": "{\"format_category\":false,\"addons\":false,\"media\":false,\"addon_emission_selected\":0,\"max_addon_emission\":0,\"media_emission_selected\":800,\"max_media_emission\":800}",
    "net_media_bugdet": "25000.00",
    "campaign_dates": "{\"start\":\"2025-05-22\",\"end\":\"2025-05-22\"}",           
    channel: "Instream Video"
}

export const MyDealsPageData = {

    ...dealInfo,
    "creative": {
        "count": 1,
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/682fb3eb932f37298a0bad04/ss/image682fb3f2aa394.jpeg"
    },
    "curated-media": {
        "count": 1,
        "type": "Pre-built"
    },
    "briefs": null,
    "slug_name": "dbm",
    "dsp": "Google Display & Video 360",
    "format_type": {
        "id": "2568ef31-343c-40ff-8fd4-f561e597557a",
        "borderColor": "#A252B0",
        "icon": null,
        "currencyCode": "AUD",
        "name": "Instream 10s",
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/prodBuddy/deal_type/image/2568ef31-343c-40ff-8fd4-f561e597557a/image6809de0b23e6f.png"
    },       

}

const dealInfoCreativeData = {
    "id": "mfd",
    "accountId": "",
    "accountName": "Account",
    "networkName": "Network",
    "name": "My fantastic campaign",
    "decarbonise": "off",
    "measure_emissions": false,
    "dspId": 2249,
    "is_mobile_app": false,
    "dealType": "CCM",
    "createdBy": "admin",
    "createdOn": "2021-12-01 10:04:12",
    "updatedOn": Date.now(),
    "selectedMedias": "nature-medias",
    "status": 1,
    "ext_campaign_id_n": "nowhere",
    "ext_campaign_id_a": "nowhere",
    "userName": "Admin",
    "isDemo": false,
    //"addon_id": 6,
    //"addons": "",
}

export const MyDealsPageCreativeData = {

    ...dealInfoCreativeData,
    "creative": {
        "count": 3,
        "image": "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/asset/cb/v2/1.jpg"
    },
    "curated-media": {
        "count": 1,
        "type": "Pre-built"
    },
    "briefs": null,
    "slug_name": "dbm",
    "dsp": "Google Display & Video 360",
    "format_type": {
        "id": "3b890151-aa35-4434-a1a8-44367f4031c1",
        "borderColor": "#A252B0",
        "icon": null,
        "name": "Premium",
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/deal_type/image/3b890151-aa35-4434-a1a8-44367f4031c1/Image (1).jpg"
    },
    "is_tnc_accepted": true,
        

}

const creativeD = [
    {
        "_id": "65c2c91b8d067835c00ae31b",
        "ad_name": "Crazy limelight",
        "width": "300",
        "height": "600",
        "accountId": "",
        "accountName": "Account",
        "dimension": "300x600",
        "device": "0",
        "ad_for": "nexd",
        "ad_type": "Limelight",
        "ad_id": "mfd",
        "creative_id": "xGKapFrEwbG3dLo1",
        "html_tag": "<ins class=\"adcads\"\r\ndata-click-tracker=\"https://bigads.co\"\r\ndata-debug=\"true\"\r\ndata-has-desktop=\"yes\"\r\ndata-preview-site=\"true\"\r\ndata-settings=\"https://data-apse1.nexd.com/ads/creatives/xGKapFrEwbG3dLo1/settings.json?d660d5ff094437ea46fc8744318631a5729503e8\"\r\ndata-stay-in-container=\"true\"\r\ndata-tracking=\"no\"\r\ndata-trackingjs=\"no\"\r\ndata-unit=\"xGKapFrEwbG3dLo1\"\r\ndata-url=\"https://data-apse1.nexd.com/ads/creatives/\">\r\n<script src=\"https://cdn.nexd.com/frmwrk/teele-release-v5.9.102.js\" type=\"text/javascript\" async></script>\r\n</ins>",
        "refName": "My fantastic campaign",
        "default_landingURL": "https://bigads.co",
        "createAt": "2021-12-01 10:42:44",
        "createBy": "admin",
        "content": [
            {
                "imageSrc": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/65c2c91b8d067835c00ae31b/Limelight.jpg",
                "createAt": "2021-12-01 10:42:44",
                "createBy": "admin"
            }
        ],
        "tagRequested": "true",
        "tagRequestedTime": "2021-12-01 10:42:44",
        "payload_size": 456292,
        "scripts": {
            "secureScript": "<ins class=\"adcads\"\r\n\tdata-adc-id=\"1aTU2LBSzVov\"\r\n\tdata-unit=\"1aTU2LBSzVov\"\r\n\tdata-clickable=\"yes\"\r\n\tdata-redir=\"yes\"\r\n\tdata-click-tracker=\"${CLICK_URL}https://bigads.co\"\r\n\tdata-click-macro=\"${CLICK_URL}\"\r\n\tdata-has-desktop=\"yes\"\r\n\tdata-responsive=\"yes\"\r\n\tdata-width=\"300\"\r\n\tdata-height=\"600\"\r\n\tdata-meta-source-url=\"${SOURCE_URL}\">\r\n\t<script src=\"https://media.adcanvas.com/1aTU2LBSzVov/adtag.js\" type=\"text/javascript\" async></script>\r\n</ins>\r\n<script type=\"text/javascript\" src=\"https://cdn.lamp.avct.cloud/attn.js?aid=62ecd351cc16059c310d8191&mid=63072fe0cc16059c310d82a1&mt=displayBanner&cp_lineItemId=aad7779c-83f0-4bb9-b78e-1ef450d2eb93&cp_creativeId=65c2c91b8d067835c00ae31b&size=300x600\"></script>",
            "adcId": "1aTU2LBSzVov"
        },
        "status": {
            "ad_live": true
        },
        "ad_server": "nexd",
        "format_type": "Infeed",
        "creative_number": 2
    },
    {
        "_id": "65c2c83a11e9d8ce2a08d0f4",
        "ad_name": "Fantastic carousel",
        "width": "300",
        "height": "600",
        "accountId": "",
        "accountName": "Account",
        "dimension": "300x600",
        "device": "0",
        "ad_for": "nexd",
        "ad_type": "Carousel",
        "ad_id": "mfd",
        "creative_id": "buZHbYbQWZjZdAHn",
        "html_tag": "<ins class=\"adcads\"\r\ndata-click-tracker=\"https://bigads.co\"\r\ndata-debug=\"true\"\r\ndata-has-desktop=\"yes\"\r\ndata-preview-site=\"true\"\r\ndata-settings=\"https://data-apse1.nexd.com/ads/creatives/buZHbYbQWZjZdAHn/settings.json?1b83c4448f72900fe56b4dd85fed3c6610781bc9\"\r\ndata-stay-in-container=\"true\"\r\ndata-tracking=\"no\"\r\ndata-trackingjs=\"no\"\r\ndata-unit=\"buZHbYbQWZjZdAHn\"\r\ndata-url=\"https://data-apse1.nexd.com/ads/creatives/\">\r\n<script src=\"https://cdn.nexd.com/frmwrk/teele-release-v5.9.102.js\" type=\"text/javascript\" async></script>\r\n</ins>",
        "refName": "My fantastic campaign",
        "default_landingURL": "https://bigads.co",
        "createAt": "2021-12-01 10:42:44",
        "createBy": "admin",
        "content": [
            {
                "imageSrc": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/65c2c83a11e9d8ce2a08d0f4/Carousel.jpg",
                "createAt": "2021-12-01 10:42:44",
                "createBy": "admin"
            }
        ],
        "tagRequested": "true",
        "tagRequestedTime": "2021-12-01 10:42:44",
        "payload_size": 730215,
        "scripts": {
            "secureScript": "<ins class=\"adcads\"\r\n\tdata-adc-id=\"qyqjBDfNo3Kt\"\r\n\tdata-unit=\"qyqjBDfNo3Kt\"\r\n\tdata-clickable=\"yes\"\r\n\tdata-redir=\"yes\"\r\n\tdata-click-tracker=\"${CLICK_URL}https://bigads.co\"\r\n\tdata-click-macro=\"${CLICK_URL}\"\r\n\tdata-has-desktop=\"yes\"\r\n\tdata-responsive=\"yes\"\r\n\tdata-width=\"300\"\r\n\tdata-height=\"600\"\r\n\tdata-meta-source-url=\"${SOURCE_URL}\">\r\n\t<script src=\"https://media.adcanvas.com/qyqjBDfNo3Kt/adtag.js\" type=\"text/javascript\" async></script>\r\n</ins>\r\n<script type=\"text/javascript\" src=\"https://cdn.lamp.avct.cloud/attn.js?aid=62ecd351cc16059c310d8191&mid=63072fe0cc16059c310d82a1&mt=displayBanner&cp_lineItemId=aad7779c-83f0-4bb9-b78e-1ef450d2eb93&cp_creativeId=65c2c83a11e9d8ce2a08d0f4&size=300x600\"></script>",
            "adcId": "qyqjBDfNo3Kt"
        },
        "status": {
            "ad_live": true
        },
        "ad_server": "nexd",
        "format_type": "Infeed",
        "creative_number": 1
    },
    {
        "_id": "65bc5b28cf2e9ce874075258",
        "ad_name": "Spinning cube V2",
        "width": "300",
        "height": "600",
        "accountId": "",
        "accountName": "Account",
        "dimension": "300x600",
        "device": "0",
        "ad_for": "nexd",
        "ad_type": "Cube",
        "ad_id": "mfd",
        "creative_id": "a2J8SpWD1EYr2EaL",
        "html_tag": "<ins class=\"adcads\"\r\ndata-click-tracker=\"https://bigads.co\"\r\ndata-debug=\"true\"\r\ndata-has-desktop=\"yes\"\r\ndata-preview-site=\"true\"\r\ndata-settings=\"https://data-apse1.nexd.com/ads/creatives/a2J8SpWD1EYr2EaL/settings.json?e4afb37b6e0f5f4e4670c36e37b68f4b0cc61a7a\"\r\ndata-stay-in-container=\"true\"\r\ndata-tracking=\"no\"\r\ndata-trackingjs=\"no\"\r\ndata-unit=\"a2J8SpWD1EYr2EaL\"\r\ndata-url=\"https://data-apse1.nexd.com/ads/creatives/\">\r\n<script src=\"https://cdn.nexd.com/frmwrk/teele-release-v5.9.102.js\" type=\"text/javascript\" async></script>\r\n</ins>",
        "refName": "My fantastic campaign",
        "default_landingURL": "https://bigads.co",
        "createAt": "2021-12-01 10:42:44",
        "createBy": "admin",
        "content": [
            {
                "imageSrc": "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/asset/cb/v2/1.jpg",
                "createAt": "2021-12-01 10:42:44",
                "createBy": "admin"
            }
        ],
        "tagRequested": "true",
        "tagRequestedTime": "2021-12-01 10:42:44",
        "payload_size": 576188,
        "scripts": {
            // eslint-disable-next-line 
            "secureScript": "<ins class=\"adcads\"\r\n\tdata-adc-id=\"6Jk0VdKPaJUH\"\r\n\tdata-unit=\"6Jk0VdKPaJUH\"\r\n\tdata-clickable=\"yes\"\r\n\tdata-redir=\"yes\"\r\n\tdata-click-tracker=\"${CLICK_URL}https://bigads.co\"\r\n\tdata-click-macro=\"${CLICK_URL}\"\r\n\tdata-has-desktop=\"yes\"\r\n\tdata-responsive=\"yes\"\r\n\tdata-width=\"300\"\r\n\tdata-height=\"600\"\r\n\tdata-meta-source-url=\"${SOURCE_URL}\">\r\n\t<script src=\"https://media.adcanvas.com/6Jk0VdKPaJUH/adtag.js\" type=\"text/javascript\" async></script>\r\n</ins>\r\n",
            "adcId": "6Jk0VdKPaJUH"
        },
        "status": {
            "ad_live": true
        },
        "ad_server": "nexd",
        "format_type": "Infeed",
        "creative_number": 0
    }

];

export const GetCuratedAd = (v = true) => ({
    "page-info": [
        {
            ...(v ?  dealInfo: dealInfoCreativeData),
            "createdByName": "Admin",
            "termsConditionsUrl": null,

        }
    ],
    "creative": v ? creative : creativeD,
    "curated-media": media,
    "briefs": null,
    "slug_name": "dbm",
    "updatedOn": Date.now(),
    "dsp": "Google Display & Video 360",
    "macros": {
        // eslint-disable-next-line 
        "click_url": "${CLICK_URL}",
        // eslint-disable-next-line 
        "cachebuster": "${CACHEBUSTER}"
    },
    "format_type": {
        "id": "3b890151-aa35-4434-a1a8-44367f4031c1",
        "borderColor": "#A252B0",
        "icon": null,
        "name": "Advanced",
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/deal_type/image/3b890151-aa35-4434-a1a8-44367f4031c1/Image (1).jpg"
    },
    dealTypeInfo:{        
        channel: "Instream Video",
        name: "Instream 10s",
        currencyCode: "AUD",
    },
    
})

export const ActivityReportLink = "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/download/report/Nature/Nature_Deal_Report_Instream.xlsx";

export const ActivityReport = {
    "result": [
        {
                "day": "2025-05-06",
                "impressions": 41,
                "measurables": 41,
                "viewables": 44,
                "interactionsTime": 0,
                "engagements": 33,
                "clicks": 15,
                "viewabilityRate": 107.32,
                "engagementRate": 80.49,
                "ctr": 36.59
            },
            {
                "day": "2025-05-07",
                "impressions": 10,
                "measurables": 10,
                "viewables": 10,
                "interactionsTime": 0,
                "engagements": 6,
                "clicks": 3,
                "viewabilityRate": 100,
                "engagementRate": 60,
                "ctr": 30
            },
            {
                "day": "2025-05-08",
                "impressions": 1270,
                "measurables": 1270,
                "viewables": 1246,
                "interactionsTime": 0,
                "engagements": 579,
                "clicks": 3,
                "viewabilityRate": 98.11,
                "engagementRate": 45.59,
                "ctr": 0.24
            },
            {
                "day": "2025-05-09",
                "impressions": 11146,
                "measurables": 11146,
                "viewables": 10896,
                "interactionsTime": 0,
                "engagements": 4673,
                "clicks": 15,
                "viewabilityRate": 97.76,
                "engagementRate": 41.93,
                "ctr": 0.13
            },
            {
                "day": "2025-05-10",
                "impressions": 7981,
                "measurables": 7981,
                "viewables": 7637,
                "interactionsTime": 0,
                "engagements": 3377,
                "clicks": 13,
                "viewabilityRate": 95.69,
                "engagementRate": 42.31,
                "ctr": 0.16
            },
            {
                "day": "2025-05-11",
                "impressions": 4068,
                "measurables": 4068,
                "viewables": 3895,
                "interactionsTime": 0,
                "engagements": 1710,
                "clicks": 5,
                "viewabilityRate": 95.75,
                "engagementRate": 42.04,
                "ctr": 0.12
            },
            {
                "day": "2025-05-12",
                "impressions": 13353,
                "measurables": 13353,
                "viewables": 12911,
                "interactionsTime": 0,
                "engagements": 5291,
                "clicks": 17,
                "viewabilityRate": 96.69,
                "engagementRate": 39.62,
                "ctr": 0.13
            },
            {
                "day": "2025-05-13",
                "impressions": 8064,
                "measurables": 8064,
                "viewables": 7692,
                "interactionsTime": 0,
                "engagements": 3434,
                "clicks": 9,
                "viewabilityRate": 95.39,
                "engagementRate": 42.58,
                "ctr": 0.11
            },
            {
                "day": "2025-05-14",
                "impressions": 3963,
                "measurables": 3963,
                "viewables": 3729,
                "interactionsTime": 0,
                "engagements": 1676,
                "clicks": 3,
                "viewabilityRate": 94.1,
                "engagementRate": 42.29,
                "ctr": 0.08
            }
    ],
    "summary": {
        "impressions": 49896,
            "measurables": 49896,
            "viewables": 48060,
            "interactionsTime": 0,
            "engagements": 20779,
            "clicks": 83,
            "viewabilityRate": 96.32,
            "engagementRate": 41.64,
            "avgEngagedTime": 6.65,
            "ctr": 0.17,
            "ad_type": "Video",
            "videoStart": 25988,
            "videoComplete": 18816,
            "firstQuartile": 22997,
            "midpoint": 21382,
            "thirdQuartile": 20205,
            "videoCompletionRate": 72.4,
            "interactionsTimeSize": 6650,
            "adserver": "nexd"
    },
    "errors": [],
    "withCreativeBreakdown": [
        {
                "creativeName": "VPAID Tracker Test",
                "impressions": 49896,
                "measurables": 49896,
                "viewables": 48060,
                "interactionsTime": 0,
                "engagements": 20779,
                "clicks": 83,
                "viewabilityRate": 96.32,
                "engagementRate": 41.64,
                "avgEngagedTime": 6.65,
                "ctr": 0.17,
                "ad_type": "Video",
                "videoStart": 25988,
                "videoComplete": 18816,
                "firstQuartile": 22997,
                "midpoint": 21382,
                "thirdQuartile": 20205,
                "videoCompletionRate": 72.4
            }
    ],
    "withSizeBreakdown": [
        {
            "size": "1920x1080",
            "impressions": 49896,
                "measurables": 49896,
                "viewables": 48060,
                "interactionsTime": 0,
                "engagements": 20779,
                "clicks": 83,
                "videoStart": 25988,
                "videoComplete": 18816,
                "viewabilityRate": 96.32,
                "engagementRate": 41.64,
                "avgEngagedTime": 6.65,
                "ctr": 0.17,
                "videoCompletionRate": 72.4
        }
    ]    
}
